'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.objectToFormData = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _featureDetection = require('../feature-detection');

/**
 * Converts a plain object map into a FormData object
 *
 * @param obj - object of form values
 * @returns FormData instance
 */
var objectToFormData = exports.objectToFormData = function objectToFormData(obj) {
    if (!_featureDetection.HAS_FORM_DATA) {
        throw new Error('Unable to convert objectToFormData in environment without FormData');
    }

    var data = new FormData();

    Object.entries(obj).forEach(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            key = _ref2[0],
            value = _ref2[1];

        return data.append(key, value);
    });

    return data;
};